import { cn } from '../../utils/cn.js';

/** The Conflui mark, with the wordmark beside it when there is room. */
export function BrandMark({ withText = true, className }: { withText?: boolean; className?: string }) {
  return (
    <span className={cn('flex items-center gap-2.5', className)}>
      <span
        aria-hidden="true"
        className="flex size-8 items-center justify-center rounded-lg bg-primary-500 text-sm font-bold text-white"
      >
        C
      </span>
      {withText && <span className="text-lg font-semibold tracking-tight text-text-primary">Conflui</span>}
    </span>
  );
}
